import { Link } from 'react-router-dom'
import { Scissors, ArrowLeftRight, ShoppingCart, PackagePlus, Package, ChevronRight } from 'lucide-react'
import { useMe } from '../lib/me.js'
import { canManage } from '../lib/role.js'

// Stock landing — mirrors the ติดตาม / Manager tool-card pattern. Order matches
// the sidebar submenu: ตัด Stock · โอนย้าย · จัดซื้อ · คลังของ · สินทรัพย์.
// สินทรัพย์ (asset register) is manager-gated — shown only to Manager / Stock
// Manager / Admin, same as its sidebar entry.
const TOOLS = [
  {
    to: '/stock/cut',
    icon: Scissors,
    title: 'ตัด Stock',
    desc: 'ประวัติการตัดของ · ตรวจสอบและแก้ไขรายการย้อนหลัง · กดตัด Stock เพื่อบันทึกของที่ใช้ไป',
    ready: true,
  },
  {
    to: '/stock/transfer',
    icon: ArrowLeftRight,
    title: 'โอนย้าย',
    desc: 'โอนของระหว่างสาขา · ขอโอนย้าย → รับของ → เสร็จสิ้น',
    ready: true,
  },
  {
    to: '/purchase',
    icon: ShoppingCart,
    title: 'จัดซื้อ',
    desc: 'คำขอซื้อ → ตรวจสอบ → ชำระเงิน → รับของ · ออกเลข PO · ผู้ขาย · ต้นทุน',
    ready: true,
  },
  {
    to: '/stock/items',
    icon: PackagePlus,
    title: 'คลังของ',
    desc: 'รายการของทั้งหมด · ยอดคงเหลือรวมและแยกสาขา · สถิติการเบิกใช้รายเดือน · แก้ไขข้อมูลของ',
    ready: true,
  },
  {
    to: '/manager/assets',
    icon: Package,
    title: 'สินทรัพย์',
    desc: 'ทะเบียนทรัพย์สิน · อายุการใช้งาน · QR code · การตรวจเช็ก และประวัติการซ่อม',
    ready: true,
    managerOnly: true,
  },
]

export default function Stock() {
  const me = useMe()
  const manager = canManage(me)
  const tools = TOOLS.filter((t) => !t.managerOnly || manager)
  return (
    <div className="px-10 py-8 max-w-[1100px]">
      <h1 className="text-[22px] font-semibold text-slate-900 tracking-tight mb-1">Stock</h1>
      <p className="text-[14px] text-slate-500 mb-7">จัดการของใช้และคลังสาขา</p>

      <div className="grid gap-4 sm:grid-cols-2">
        {tools.map(({ to, icon: Icon, title, desc, ready }) => {
          const inner = (
            <>
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${
                ready ? 'bg-brand-50 text-brand-600' : 'bg-slate-100 text-slate-400'
              }`}>
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1 text-[15.5px] font-semibold text-slate-900">
                  {title}
                  {ready
                    ? <ChevronRight size={16} className="text-slate-300 group-hover:text-brand-400 transition" />
                    : <span className="ml-1.5 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-400">เร็วๆ นี้</span>}
                </div>
                <p className="text-[13px] text-slate-500 mt-1 leading-relaxed">{desc}</p>
              </div>
            </>
          )
          const cls = 'rounded-2xl border p-5 flex items-start gap-4 transition'
          return ready ? (
            <Link key={to} to={to} className={`group ${cls} border-slate-200 bg-white shadow-sm hover:border-brand-300 hover:shadow-md`}>
              {inner}
            </Link>
          ) : (
            <div key={to} className={`${cls} border-dashed border-slate-200 bg-white/50 cursor-default`}>
              {inner}
            </div>
          )
        })}
      </div>
    </div>
  )
}
